{
  "id": "wrangled",
  "version": 0,
  "name": "Unknown",
  "author": "",
  "date": "2023-01-01",
  "url": "",
  "strings": {
    "en": {
      "name": "Automatically Processed Data",
      "help": [
        "Datasets TransparencyVis does not know can still be processed.",
        "The results may contain errors and may be changed using the expert mode."
      ]
    },
    "de": {
      "name": "Automatisch verarbeitete Daten",
      "help": [
        "Datensätze, über die TransparencyVis keine Informationen hat, werden ohne weitere Kenntnisse gelesen.",
        "Die Ergebnisse könnten fehlerhaft verarbeitet werden, über den Expertenmodus können die Ergebnisse angepasst werden."
      ]
    }
  },
  "instructions": [],
  "fileStructure": [],
  "optionalFileStructure": [],
  "hidden": true
}
